import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  touch() {
    this.dispatch('touched', { target: window });
  }
}
